import { Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';

import { StateLinkList } from './StateLinkList';
import type { StateLink } from './StateLinkList';

interface EmptyStateNearbyProps {
  stateName: string;
  nearestStates: StateLink[];
  allStates: StateLink[];
}

export const EmptyStateNearby: React.FC<EmptyStateNearbyProps> = ({
  stateName,
  nearestStates,
  allStates,
}) => {
  return (
    <Col>
      <Col className="items-center px-3 py-6">
        <Col className="w-full max-w-200 items-center text-center">
          <Text as="h1" className="text-header-lg pb-3">
            Homes for Sale in {stateName}
          </Text>

          <Text as="p" className="text-body-lg pb-4">
            No homes available in {stateName} yet. Browse these homes in nearby states:
          </Text>

          <Row className="flex-wrap justify-center gap-4 pb-4">
            {nearestStates.length > 0 ? (
              nearestStates.map((state) => {
                const label = `${state.name} (${state.count} ${state.count === 1 ? 'home' : 'homes'})`;
                return (
                  <Button
                    key={state.slug}
                    analyticsName="nearby-state-link"
                    href={`/homes/state/${state.slug}`}
                    variant="secondary"
                    aria-label={label}
                  >
                    {label}
                  </Button>
                );
              })
            ) : (
              <Button
                analyticsName="view-all-markets"
                href="/homes"
                variant="primary"
                aria-label="View all available markets"
              >
                View all available markets
              </Button>
            )}
          </Row>

          <Col className="pt-6">
            <Button
              analyticsName="view-all-markets-footer"
              href="/homes"
              variant="secondary"
              aria-label="View all available markets"
            >
              View all available markets →
            </Button>
          </Col>
        </Col>
      </Col>

      <StateLinkList states={allStates} />
    </Col>
  );
};
